module.exports = __webpack_public_path__ + "static/media/my-account-bg.5a2bc3e5.jpg";